import { Injectable } from "@angular/core";
import { HttpClient, HttpHeaders } from "@angular/common/http";
import { environment } from "src/environments/environment";
import { CookieService } from "ngx-cookie-service";
import { EncryptDecryptService } from "../encrypt-decrypt.service";

@Injectable({ providedIn: "root" })
export class MembershipService {
  headerObj;
  httpOptions;
  MerchantID = "1fcc23f1-edd1-4b29-9d4a-be5416fc6c9c";
  APIKey = "V>m+[P";
  constructor(
    private http: HttpClient,
    private cookieService: CookieService,
    private encDecService: EncryptDecryptService
  ) {}

  GetPlansbyMembershipTypeID(MembershipTypeID) {
    return this.http.get(
      environment.configUrl +
        "Membership/GetPlansbyMembershipTypeID?MemberShipTypeID=" +
        MembershipTypeID +
        "&CurrentDate=" +
        new Date()
    );
  }

  InsertMembershipPlanPatientLink(
    MembershipPlanID,
    PatientID,
    MembershipPatientLinkID,
    AppointmentScheduleSlotLevelID
  ) {
    return this.http.get(
      environment.configUrl +
        "Membership/InsertMembershipPlanPatientLink?MembershipPlanID=" +
        this.encDecService.enc(MembershipPlanID.toString()) +
        "&PatientID=" +
        this.encDecService.enc(PatientID.toString()) +
        "&MembershipPatientLinkID=" +
        this.encDecService.enc(MembershipPatientLinkID.toString()) +
        "&AppointmentScheduleSlotLevelID=" +
        this.encDecService.enc(AppointmentScheduleSlotLevelID.toString()) +
        "&CurrentDate=" +
        new Date()
    );
  }

  // paypal
  InsertTransaction(TransactionData) {
    var Data = {
      TransactionData: this.encDecService.enc(JSON.stringify(TransactionData)),
    };
    return this.http.post(
      environment.configUrl +
        "Transaction/InsertTransaction?&CurrentDate=" +
        new Date(),
      Data
    );
  }
}

// InsertMembershipData(memberShipData) {
//     return this.http.post(environment.configUrl + 'Membership/InsertMemberShipUser?CurrentDate=' + new Date(), memberShipData)
// }

// GetAllMembershipTypes() {
//     return this.http.get(environment.configUrl + 'Membership/GetAllMembershipTypes?CurrentDate=' + new Date())
// }
